import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const Styled3DButton = styled(Button)(({ theme, customcolor }) => ({
  backgroundColor: customcolor || '#1976d2',
  color: '#fff',
  fontWeight: 700,
  textTransform: 'none',
  padding: '10px 24px',
  borderRadius: '12px',
  fontSize: '1rem',
  transition: 'all 0.1s ease',
  position: 'relative',
  // The "Depth" of the button
  boxShadow: `0px 6px 0px 0px ${customcolor ? 'rgba(0,0,0,0.2)' : '#115293'}`,
  border: '1px solid rgba(255,255,255,0.1)',

  '&:hover': {
    backgroundColor: customcolor || '#1565c0',
    transform: 'translateY(2px)',
    boxShadow: `0px 4px 0px 0px ${customcolor ? 'rgba(0,0,0,0.2)' : '#115293'}`,
  },

  '&:active': {
    transform: 'translateY(6px)', // Moves down to "cover" the shadow
    boxShadow: '0px 0px 0px 0px transparent', // Shadow disappears as it hits the "floor"
  },

  '& .MuiButton-startIcon, & .MuiButton-endIcon': {
    transition: 'transform 0.2s ease',
  },

  '&:hover .MuiButton-endIcon': {
    transform: 'translateX(4px)', // Subtle movement on hover
  },
}));

const CustomButton = ({ title, startIcon, endIcon, onClick, color }) => {
  return (
    <Styled3DButton
      variant="contained"
      disableRipple // Ripple can break the 3D "solid" illusion
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      customcolor={color}
    >
      {title}
    </Styled3DButton>
  );
};

export default CustomButton;